<script setup lang="ts">
const { $log } = useLogging();
const { $alert } = useAlerts();

defineExpose({
    init(editor: any)
    {
        editor.ui.registry.addMenuItem('premium', {
            icon: 'lock',
            text: $t('[[[Treść premium]]]'),
            onAction: async (): Promise<void> =>
            {
                try
                {
                    const htmlToAdd = `<div data-component="premium" data-props="{}" style="text-align: center; padding: 10px; background: #eaeaea; border-radius: 5px;" class="mceNonEditable">
                        ${$t('[[[Dalsza część artykułu przeznaczona jest dla osób z subskrypcją premium]]]')}
                    </div>`;

                    editor.execCommand('mceInsertContent', false, htmlToAdd);
                }
                catch (ex)
                {
                    handleException($log, ex, {
                        400: (ex: any) => $alert.warning(ex.message)
                    });
                }
            },
            onSetup: function (api: any)
            {
                const checkVisibility = () =>
                {
                    const content = editor.getContent();
                    const hasPremium = content.includes('data-component="premium"');

                    api.setEnabled(!hasPremium);
                };

                checkVisibility();

                editor.on('NodeChange KeyUp SetContent', checkVisibility);

                return function ()
                {
                    editor.off('NodeChange KeyUp SetContent', checkVisibility);
                };
            }
        });
    }
});
</script>

<template>
    <div v-if="false" />
</template>
